class Header {
    constructor() {
        this.init();
    }

    init() {
    }

    static RWDMenu() {
        $('.toggle-menu').on('click', (e) => {
            let $_ = $(e.delegateTarget);
            $('html').toggleClass('rwd-menu rwd-menu-active overflow-mobile');
        });
    }

    static RWDAdminMenu() {
        const togglers = document.querySelectorAll('[data-toggle-menu]');
        const nav = document.querySelector('[data-nav-to-toggle]');
        const body = document.body;
        if (!togglers.length || !nav || !body) return;

        const toggleMenuClasses = toggler => {
            if (!toggler) {
                togglers.forEach(toggler => toggler.classList.toggle('is-active'));
            } else {
                toggler.classList.toggle('is-active');
            }
            nav.classList.toggle('is-active');
            body.classList.toggle('overlay-active');
        };

        togglers.forEach(toggler => {
            toggler.addEventListener('click', function(e) {
                toggleMenuClasses(this);
            });
        });

        document.addEventListener('click', e => {
            if (!e.target.closest('[data-nav-to-toggle]') && !e.target.closest('.hamburger') && nav.classList.contains('is-active')) {
                toggleMenuClasses(false);
            }
        })
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/assets/js/components/Header.js